import { Controller } from "@hotwired/stimulus"
import { TwoFactorCredentialMode } from "../components/two-factor-credential-mode"

export default class extends Controller {
  static targets = ["otpPanel", "recoveryPanel", "otpInput", "recoveryInput", "description", "recoverySwitch", "otpSwitch"]
  static values = { initialMode: { type: String, default: "otp" } }

  connect() {
    this.mode = new TwoFactorCredentialMode({
      otpPanel: this.otpPanelTarget,
      recoveryPanel: this.recoveryPanelTarget,
      otpInput: this.otpInputTarget,
      recoveryInput: this.recoveryInputTarget,
      description: this.descriptionTarget,
      recoverySwitch: this.recoverySwitchTarget,
      otpSwitch: this.otpSwitchTarget
    })
    this.mode.show(this.initialModeValue, { focus: false })
  }

  showRecovery(event) {
    event.preventDefault()
    this.mode.show("recovery")
  }

  showOtp(event) {
    event.preventDefault()
    this.mode.show("otp")
  }
}
